import { useEffect } from "react";
import { motion, useMotionValue, useSpring, useTransform } from "framer-motion";

export default function BackgroundFX() {
  const mx = useMotionValue(0);
  const my = useMotionValue(0);
  const sx = useSpring(mx, { stiffness: 45, damping: 22 });
  const sy = useSpring(my, { stiffness: 45, damping: 22 });
  const sunX = useTransform(sx, [-0.5, 0.5], [-26, 26]);
  const sunY = useTransform(sy, [-0.5, 0.5], [-16, 16]);

  useEffect(() => {
    const handleMove = (e) => {
      mx.set(e.clientX / window.innerWidth - 0.5);
      my.set(e.clientY / window.innerHeight - 0.5);
    };
    window.addEventListener("mousemove", handleMove);
    return () => window.removeEventListener("mousemove", handleMove);
  }, [mx, my]);

  return (
    <div className="fixed inset-0 z-0 overflow-hidden" aria-hidden>
      <div className="absolute inset-0 bg-gradient-to-b from-sky-200 via-sky-100 to-cyan-50" />
      <motion.div
        style={{ x: sunX, y: sunY }}
        className="absolute -top-20 right-[6%] w-[40vmin] h-[40vmin] rounded-full bg-gradient-to-br from-amber-200 via-amber-300 to-orange-300 opacity-90"
        animate={{ scale: [1, 1.07, 1] }}
        transition={{ duration: 7, repeat: Infinity, ease: "easeInOut" }}
      />
      <div className="absolute -top-20 right-[6%] w-[40vmin] h-[40vmin] rounded-full bg-amber-300/50 blur-[90px]" />
      <div className="absolute -left-28 top-1/3 w-[55vmin] h-[55vmin] rounded-full bg-sky-300/40 blur-[100px]" />
      <div className="absolute bottom-[-32%] left-1/2 -ml-[75vmin] w-[150vmin] h-[72vmin] rounded-[100%] bg-cyan-200/60 blur-[50px]" />
      <div className="absolute bottom-[-38%] left-1/2 -ml-[85vmin] w-[170vmin] h-[72vmin] rounded-[100%] bg-sky-300/40 blur-[70px]" />
    </div>
  );
}
